/*
 *
 * Do not edit directly
 * Generated on Fri, 14 Feb 2025 18:58:13 GMT
 *
 */

import PaletteIconCheckMark from '@telus-uds/palette-public-mobile/build/rn/icons/CheckMark'
import PaletteIconError from '@telus-uds/palette-public-mobile/build/rn/icons/Error'
const theme = {
  appearances: {
    icon: { type: 'variant', values: [ true ] },
    validation: {
      description: 'Validation states for form inputs',
      type: 'state',
      values: [ 'error', 'success', 'warning' ]
    }
  },
  rules: [
    {
      if: { validation: 'success' },
      tokens: { backgroundColor: '#eaf3f1' }
    },
    {
      if: { validation: 'error' },
      tokens: { backgroundColor: '#f9e8e9' }
    },
    {
      if: { icon: true, validation: 'success' },
      tokens: { icon: PaletteIconCheckMark, iconColor: '#2b826e' }
    },
    {
      if: { icon: true, validation: 'error' },
      tokens: { icon: PaletteIconError, iconColor: '#bf1722' }
    }
  ],
  tokens: {
    backgroundColor: '#f5f5f7',
    borderColor: null,
    borderRadius: 4,
    borderWidth: 0,
    color: '#394056',
    contentFontSize: 18,
    fontName: 'SofiaPro',
    fontWeight: '400',
    icon: null,
    iconColor: 'rgba(0, 0, 0, 0)',
    iconGap: 8,
    iconSize: 24,
    lineHeight: 1.5,
    paddingBottom: 12,
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 12,
    space: 2,
    titleFontSize: 18
  }
}
export default theme
